import React, { useEffect, useRef, useState } from 'react'
import Icons from '../../../../Constants/Icons'
import { onGetCategoryWiseInterestList } from '../../../../Core/Apicall'
import { useDispatch } from 'react-redux'
import {
  setLoadingFalse,
  setLoadingTrue
} from '../../../../Config/Actions/loadingActions'
import { useFormContext } from '../FormProvider'
import styles from '../../../Style'

function ArtTypeModel () {
  const { formData, setFormData, errors } = useFormContext()
  const [isOpen, setIsOpen] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null)
  const [cur_section, setCurSection] = useState('')
  const [items, setEventType] = useState([])

  const dispatch = useDispatch()
  useEffect(() => {
    onApiCallCategoryList()
  }, [])

  const onApiCallCategoryList = async selectedPage => {
    dispatch(setLoadingTrue())
    const param = {
      status: null,
      offset: selectedPage?.selected + 1 || 1,
      limit: 15
    }
    try {
      const res = await onGetCategoryWiseInterestList(param)
      setEventType(res?.data)
      dispatch(setLoadingFalse())
    } catch (error) {
      dispatch(setLoadingFalse())
    }
  }
  const toggleDropdown = () => {
    setIsOpen(!isOpen)
  }

  const handleItemClick = item => {
    setSelectedItem(item)
    setIsOpen(false)
    setCurSection(item)
    setFormData(prevForm => ({
      ...prevForm,
      ArtType: item.artName,
      categoryId: item.artId
    }))
  }

  const handleMouseLeave = () => {
    setIsOpen(false)
  }

  return (
    <div
      className={`mb-4 Category_name Subcategory_drop ${
        errors.ArtType ? 'invalid' : 'valid'
      }`}
      style={styles.CustomDrop}
    >
      <div
        onMouseLeave={() => handleMouseLeave()}
        onClick={toggleDropdown}
        className='custom-dropdown'
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            height: 26
          }}
        >
          <div
            onClick={toggleDropdown}
            style={{
              fontWeight: '400',
              color: 'white',
              width: '100%'
            }}
            className='custom-dropdown2'
          >
            {formData.ArtType === '' || formData.ArtType === null ? (
              <div style={{ color: 'rgb(129, 129, 129)' }}>Art Type</div>
            ) : (
              formData.ArtType
            )}
          </div>
          <div style={{ display: 'flex' }}>
            <img className='downArrowIcon' alt='' src={Icons.ic_down} />
          </div>
        </div>
        {isOpen && (
          <div style={{ position: 'absolute', width: '100%', left: '0px' }}>
            <div style={{ height: 10 }}></div>

            <ul style={{}} className='dropdown-menu'>
              {items.map((item, index) => (
                <li
                  className={item === cur_section ? 'active' : ''}
                  key={index.toString()}
                  onClick={() => handleItemClick(item)}
                >
                  {item.artName}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  )
}

export default ArtTypeModel
